module.exports = __webpack_public_path__ + "static/media/okinawa.3c972463.png";